import React from 'react';
import ImageLoad from 'components/ImageLoad';
import notImage from 'images/foto_en_preparacion.png';
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR

const BannerTop = (props) => {

    let {banner} = props;
    const customStyle = {
        backgroundColor: banner && banner.background_color
    };

    let imageResponsive = {
        860: banner && banner.image_mobile ? banner.image_mobile : '',
        1440: banner && banner.image_desktop ? banner.image_desktop : ''
    };

    let bannerTopAlt = banner && banner.image_desktop;
    if(!banner) return ''; 
    return(
        <section style={customStyle}>
            <div className='banner-top-offer-container' >
                {(banner.imagen_mobile || banner.image_desktop) && <ImageLoad src={banner.image_desktop} srcSet={imageResponsive} alt={bannerTopAlt} />}
                {!(banner.imagen_mobile || banner.image_desktop) && <img src={notImage} />}
            </div>
        </section>
    )
}

BannerTop.propTypes = {
    banner: PropTypes.object
}

export default BannerTop;